import { render, staticRenderFns } from "./realUp.vue?vue&type=template&id=51dcf32a&"
import script from "./realUp.vue?vue&type=script&lang=js&"
export * from "./realUp.vue?vue&type=script&lang=js&"
import style0 from "./realUp.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports